import { AfterViewInit, Directive, ElementRef, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

const FOCUS = {root: 'ngb-modal-window', title: '.modal-title', label: 'aria-label', modal: 'aria-modal',
  enabled: 'true', first: 0, lastOffset: 1,
  candidates: 'a[href],button,input,select,textarea,[tabindex]'};

@Directive({selector: '[appWorkflowModalFocus]'})
export class WorkflowModalFocusDirective implements AfterViewInit {
  private root: HTMLElement;
  constructor(private element: ElementRef, @Inject(DOCUMENT) private browserDocument: Document) {}
  ngAfterViewInit(): void {
    this.root = this.element.nativeElement.closest(FOCUS.root);
    if (!this.root) { return; }
    const title = this.root.querySelector(FOCUS.title);
    this.root.setAttribute(FOCUS.modal, FOCUS.enabled);
    if (title) { this.root.setAttribute(FOCUS.label, title.textContent.trim()); }
  }
  @HostListener('document:keydown.tab', ['$event'])
  @HostListener('document:keydown.shift.tab', ['$event'])
  onTab(event: KeyboardEvent): void {
    const active = this.browserDocument.activeElement;
    if (!this.root || !this.root.contains(active)) { return; }
    const candidates: HTMLElement[] = Array.prototype.slice.call(this.root.querySelectorAll(FOCUS.candidates));
    const controls = candidates.filter(node => node.tabIndex >= FOCUS.first &&
      !node.hasAttribute(DISABLED) && !!node.getClientRects().length);
    const first = controls[FOCUS.first];
    const last = controls[controls.length - FOCUS.lastOffset];
    const boundary = event.shiftKey ? first : last;
    if (!first || active === boundary || active === this.root) {
      event.preventDefault(); (event.shiftKey ? last || this.root : first || this.root).focus();
    }
  }
}
const DISABLED = 'disabled';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/workflow-modal-focus.directive.ts